import MainLayout from 'app/layout/MainLayout';

const NexusLayouts = {
  MainLayout,
};

export default NexusLayouts;
